import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

export default function Contacts() {
  const { t, i18n } = useTranslation();
  return (
    <div className="flex-grow w-full max-w-2xl mx-auto p-4 sm:p-8 mt-8">
      <Helmet>
        <title>{t('meta_title_contacts')}</title>
        <meta name="description" content={t('meta_desc_contacts')} />
        
        {/* Social Media Meta */}
        <meta property="og:title" content={t('meta_title_contacts')} />
        <meta property="og:description" content={t('meta_desc_contacts')} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={t('meta_title_contacts')} />
        <meta name="twitter:description" content={t('meta_desc_contacts')} />

        {/* Structured Data */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "WebPage",
              "name": "${t('meta_title_contacts')}",
              "description": "${t('meta_desc_contacts')}"
            }
          `}
        </script>
      </Helmet>
      <h1 className="text-3xl font-bold mb-6">{t('contacts_title')}</h1>
      
      <div className="bg-white/5 border border-white/10 rounded-3xl p-8 backdrop-blur-sm shadow-xl">
        <h2 className="text-xl font-semibold mb-6">{t('get_in_touch', 'Get in Touch')}</h2>
        
        <div className="space-y-6 text-white/80">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 rounded-full bg-indigo-600/20 flex items-center justify-center shrink-0 text-indigo-400">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path></svg>
            </div>
            <div>
              <p className="text-sm text-white/50 mb-1">{t('contact_name', 'Name')}</p>
              <p className="font-medium text-white">{i18n.language === 'ru' ? 'Янс Олсен' : 'Yans Olsen'}</p>
            </div>
          </div>
          
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 rounded-full bg-indigo-600/20 flex items-center justify-center shrink-0 text-indigo-400">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>
            </div>
            <div>
              <p className="text-sm text-white/50 mb-1">{t('contact_email', 'Email')}</p>
              <a href="mailto:office@free-barcode-generator.online" className="font-medium text-indigo-400 hover:text-indigo-300 transition-colors">
                office@free-barcode-generator.online
              </a>
            </div>
          </div>

          <div className="flex items-start gap-4">
            <div className="w-10 h-10 rounded-full bg-indigo-600/20 flex items-center justify-center shrink-0 text-indigo-400">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"></path>
              </svg>
            </div>
            <div>
              <p className="text-sm text-white/50 mb-1">{t('contact_twitter', 'X (Twitter)')}</p>
              <a href="https://x.com/yansolsen" target="_blank" rel="noopener noreferrer" className="font-medium text-indigo-400 hover:text-indigo-300 transition-colors">
                @yansolsen
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
